import React from "react";
import "./error-alert.scss";

interface ErrorAlertProps {
  message: string | null;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div className="error-alert">
      <div className="error-alert-content">
        <span className="error-alert-icon">⚠</span>
        <span className="error-alert-message">{message}</span>
      </div>
    </div>
  );
};

export default ErrorAlert;
